module.exports = __webpack_public_path__ + "static/img/thebean446.a84068b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/conversion/testimonial/thebean446.png
// module id = 5RrI
// module chunks = 35